module.exports = __webpack_public_path__ + "img/Logo_AUS.050ad8e4.png";